import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState, { exportUtil } from "../../baseState";
import CommonMsg from "@com/loading/CommonMsg";

export default class terminalState extends baseState {
  // 获取终端列表
  @observable list = {};
  @action
  setList = data => this.list = data;

  getList = data => {
    return this.fetch({
      url: apiUrl.TERMINAL.LIST,
      method: 'get',
      setState: "setList",
      data
    });
  }
  // 获取在线设备
  getOnlineList = data => {
    return this.fetch({
      url: apiUrl.TERMINAL.ONLINE_LIST,
      data
    });
  }
  // 添加终端
  add = data => this.fetch({
    url: apiUrl.TERMINAL.ADD,
    data
  });
  // 重启终端
  reStart = (data, id) => this.fetch({
    url: apiUrl.TERMINAL.RESTART + id,
    data
  });
  // 修改终端别名
  updateName = data => this.fetch({
    url: apiUrl.TERMINAL.UPDATE_NAME,
    data
  });
  // 删除终端
  delete = id => this.fetch({
    url: apiUrl.TERMINAL.DELETE + id,
  });
  // 获取终端详情
  getInfo = (data, id) => {
    return this.fetch({
      url: apiUrl.TERMINAL.DETAIL + id,
      data
    });
  }
  // 获取终端网络状态
  getNetInfo = (data, id) => {
    return this.fetch({
      url: apiUrl.TERMINAL.NET_DETAIL + id,
      data
    });
  }
  // 获取网络状态中的聚合信息
  getAggInfo = (data, id) => {
    return this.fetch({
      url: apiUrl.TERMINAL.AGG_DETAIL + id,
      data
    });
  }
  // 更新网络状态中的聚合信息
  updateAgg = (data, id) => {
    return this.fetch({
      url: apiUrl.TERMINAL.UPDATE_AGG + id,
      data
    });
  }
  // 升级终端
  upgrade = (data, id) => {
    return this.fetch({
      url: apiUrl.TERMINAL.UPGRADE + id,
      data
    },
      res => {
        CommonMsg.success(res.message || '');
      }
    );
  }
  // 检查终端是否有新版本
  checkUpgrade = data => {
    return this.fetch({
      url: apiUrl.TERMINAL.CHECK_UPGRADE,
      method: 'get',
      data,
    });
  }

  // 下载日志
  // downloadLog = id => {
  //   return this.fetch({
  //     url: apiUrl.TERMINAL.LOG,
  //     method: 'get',
  //     data: { id }
  //   });
  // }
  downloadLog = id => exportUtil({ data: { id }, url: apiUrl.TERMINAL.LOG });

  // 获取终端位置信息
  getPosition = id => {
    return this.fetch({
      url: apiUrl.TERMINAL.POSITION + id,
      method: 'get',
    });
  }
}
